import type { loadPyodide, PyodideInterface } from "pyodide";

interface PyodideModule {
  loadPyodide: typeof loadPyodide;
}

export class PyodideManager {
  static pyodideModule: PyodideModule | undefined;

  static async ensurePyodideModule(): Promise<PyodideModule> {
    if (this.pyodideModule) {
      return this.pyodideModule;
    }
    const pyodideModule = await import(
      /* @vite-ignore */ `${location.origin}/pyodide-0.27.4/pyodide.mjs`
    );
    this.pyodideModule = pyodideModule;
    return pyodideModule;
  }

  static async startSession(
    packages: string[],
    callback?: (status: string) => void,
  ) {
    const pyodideModule = await PyodideManager.ensurePyodideModule();
    const pyodide = await pyodideModule.loadPyodide();
    const session = new PyodideSession(pyodide);
    for (const pkg of packages) {
      callback?.(`loading ${pkg}`);
      await session.addPackage(pkg);
    }
    return session;
  }
}

export class PyodideSession {
  private readonly pyodide: PyodideInterface;

  constructor(pyodide: PyodideInterface) {
    this.pyodide = pyodide;
  }

  public async addPackage(pkg: string) {
    await this.pyodide.loadPackage(pkg);
  }

  public writeFile(path: string, content: string) {
    this.pyodide.FS.writeFile(path, content);
  }

  public async run(code: string) {
    return await this.pyodide.runPythonAsync(code);
  }
}
